// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.passation-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.passation-modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.passation-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 30px;
  border-bottom: 1px solid #e5e7eb;
}

.passation-modal-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

.passation-modal-close {
  background: none;
  border: none;
  font-size: 28px;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s, color 0.2s;
}

.passation-modal-close:hover {
  background-color: #f3f4f6;
  color: #1f2937;
}

.passation-modal-body {
  padding: 30px;
}

.passation-info-box {
  background-color: #eff6ff;
  border-left: 4px solid #3b82f6;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 24px;
}

.passation-info-text {
  margin: 0;
  color: #1e40af;
  font-size: 14px;
  line-height: 1.6;
}

.passation-form-group {
  margin-bottom: 24px;
}

.passation-form-group label {
  display: block;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
  font-size: 14px;
}

.passation-form-group .required {
  color: #dc2626;
}

.passation-select {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #1f2937;
  background-color: white;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.passation-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.passation-select:disabled {
  background-color: #f9fafb;
  cursor: not-allowed;
  opacity: 0.6;
}

.passation-warning-box {
  background-color: #fef3c7;
  border-left: 4px solid #f59e0b;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}

.passation-warning-text {
  margin: 0;
  color: #92400e;
  font-size: 13px;
  line-height: 1.6;
}

.passation-error-box {
  background-color: #fee2e2;
  border-left: 4px solid #dc2626;
  padding: 16px;
  border-radius: 8px;
  margin-top: 16px;
}

.passation-error-text {
  margin: 0;
  color: #991b1b;
  font-size: 14px;
  font-weight: 500;
}

.passation-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 30px;
  border-top: 1px solid #e5e7eb;
  background-color: #f9fafb;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

/* Responsive */
@media (max-width: 640px) {
  .passation-modal-content {
    max-width: 100%;
    margin: 0 10px;
  }

  .passation-modal-header,
  .passation-modal-body,
  .passation-modal-footer {
    padding: 20px;
  }

  .passation-modal-footer {
    flex-direction: column;
  }

  .passation-modal-footer button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/composants/PassationModal/PassationModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA,eAAe;AACf;EACE;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".passation-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.passation-modal-content {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  max-width: 600px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(-50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.passation-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 30px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.passation-modal-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.passation-modal-close {\n  background: none;\n  border: none;\n  font-size: 28px;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.passation-modal-close:hover {\n  background-color: #f3f4f6;\n  color: #1f2937;\n}\n\n.passation-modal-body {\n  padding: 30px;\n}\n\n.passation-info-box {\n  background-color: #eff6ff;\n  border-left: 4px solid #3b82f6;\n  padding: 16px;\n  border-radius: 8px;\n  margin-bottom: 24px;\n}\n\n.passation-info-text {\n  margin: 0;\n  color: #1e40af;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.passation-form-group {\n  margin-bottom: 24px;\n}\n\n.passation-form-group label {\n  display: block;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 8px;\n  font-size: 14px;\n}\n\n.passation-form-group .required {\n  color: #dc2626;\n}\n\n.passation-select {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #1f2937;\n  background-color: white;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.passation-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.passation-select:disabled {\n  background-color: #f9fafb;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.passation-warning-box {\n  background-color: #fef3c7;\n  border-left: 4px solid #f59e0b;\n  padding: 16px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n}\n\n.passation-warning-text {\n  margin: 0;\n  color: #92400e;\n  font-size: 13px;\n  line-height: 1.6;\n}\n\n.passation-error-box {\n  background-color: #fee2e2;\n  border-left: 4px solid #dc2626;\n  padding: 16px;\n  border-radius: 8px;\n  margin-top: 16px;\n}\n\n.passation-error-text {\n  margin: 0;\n  color: #991b1b;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.passation-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 20px 30px;\n  border-top: 1px solid #e5e7eb;\n  background-color: #f9fafb;\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n  .passation-modal-content {\n    max-width: 100%;\n    margin: 0 10px;\n  }\n\n  .passation-modal-header,\n  .passation-modal-body,\n  .passation-modal-footer {\n    padding: 20px;\n  }\n\n  .passation-modal-footer {\n    flex-direction: column;\n  }\n\n  .passation-modal-footer button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
